import { defineMessages } from 'react-intl';

export default defineMessages({
    mortgageValidationMsg: {
        id: 'tfpa.quoteandbind.contacts.policyroles.Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third',
        defaultMessage: 'Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third.',
    },
    mortgageValidationTitle: {
        id: 'tfpa.quoteandbind.contacts.policyroles.Invalid Mortgage Positions',
        defaultMessage: 'Invalid Mortgage Positions',
    },
    yesModal: {
        id: 'tfpa.translation.additionalInformation.Yes',
        defaultMessage: 'Yes'
    },
    noModal: {
        id: 'tfpa.translation.additionalInformation.No',
        defaultMessage: 'No'
    },
    saveFailedMsg: {
        id: 'tfpa.quoteandbind.contacts.policyroles.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'tfpa.quoteandbind.contacts.policyroles.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
        id: 'tfpa.translation.additionalInformation.Cancel',
        defaultMessage: 'Cancel'
    },
    removeAdditionalInterest: {
        id: 'tfpa.translation.additionalInformation.Remove Additional Interest',
        defaultMessage: 'Remove Additional Interest?'
    },
    removeAddlInterestMessage: {
        id: 'tfpa.translation.additionalInformation.Are you sure you want to remove this contact?',
        defaultMessage: 'Are you sure you want to remove this item?'
    },
    contractofSale: {
        id: 'tfpa.translation.additionalInformation.Contract of Sale',
        defaultMessage: 'Contract of Sale'
    },
    mortgagee: {
        id: 'tfpa.translation.additionalInformation.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    alternatePayor: { // DE18024
        id: 'tfpa.translation.additionalInformation.AlternatePayor',
        defaultMessage: 'Alternate Payor'
    },
    mortgageeEscrow: {
        id: 'tfpa.translation.additionalInformation.mortgageeEscrow',
        defaultMessage: 'Mortgagee Escrow'
    },
    lossPayee: {
        id: 'tfpa.translation.additionalInformation.Loss Payee',
        defaultMessage: 'Loss Payee'
    },
    premiumFinance: {
        id: 'tfpa.translation.additionalInformation.Premium Finance',
        defaultMessage: 'Premium Finance'
    },
    firstMortgagee: {
        id: 'tfpa.translation.additionalInformation.First Mortgage',
        defaultMessage: 'First Mortgage'
    },
    secondMortgagee: {
        id: 'tfpa.translation.additionalInformation.Second Mortgage',
        defaultMessage: 'Second Mortgage'
    },
    thirdMortgagee: {
        id: 'tfpa.translation.additionalInformation.Third Mortgage',
        defaultMessage: 'Third Mortgage'
    },
    close: {
        id: 'tfpa.quoteandbind.residential.additionalInsured.Close',
        defaultMessage: 'Close'
    },
    invalidMortgagePosition: {
        id: 'tfpa.quoteandbind.residential.additionalInsured.invalidMortgagePosition',
        defaultMessage: 'Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third.'
    }
    
});
